angular.module('impactx.purchaserequest').controller('AddToBasketOrderController', [
    '$scope',
    '$mdDialog',
    'dataGen',
    'multipleSelection',
    AddToBasketOrderController]);

function AddToBasketOrderController($scope, $mdDialog, dataGen, multipleSelection) {

    dataGen.postAsForm($scope, {multipleSelection: multipleSelection}, "/basket/addtobasket/config/view");

    $scope.selectAll = function(selection) {
        if($scope.data.addControls && !$scope.data.addControls.readOnly)
        {
            $scope.data.addControls.value = selection;
        }
        if($scope.data.addSPO && !$scope.data.addSPO.readOnly)
        {
            $scope.data.addSPO.value = selection;
        }
        if($scope.data.addOGD && !$scope.data.addOGD.readOnly)
        {
            $scope.data.addOGD.value = selection;
        }
    };

    $scope.cancel = function() {
        $mdDialog.cancel();
    };

    $scope.confirm = function() {
        $mdDialog.hide($scope.data);
    };
}